import { Button, Popover, Stack, Typography } from '@mui/material';

import first from 'lodash/first';

import PlusIcon from '@/components/Icons/PlusIcon';
import SettingsIcon from '@/components/Icons/SettingsIcon';
import UserPlusIcon from '@/components/Icons/UserPlusIcon';
import { BasetenPageEnum, usePageSwitcher } from '@/routes';
import { Avatar } from '@/sections/GlobalHeader/Left/WorkspaceLink/styled';
import { useDialogs } from '@toolpad/core/useDialogs';

import { MenuItem, TeamResource, TeamResourceName } from '../../styled';
import CreateTeam from '../CreateTeam';
import { Container, Section } from './styled';
import { ManagePopoverProps } from './types';

function ManagePopover({
  onClose,
  anchorEl,
  teams,
  selectedTeamId,
  onSelectTeam,
}: ManagePopoverProps) {
  const selectedTeam = teams?.find((team) => team.id === selectedTeamId);
  const goToPage = usePageSwitcher();
  const dialogs = useDialogs();

  function goToTeamSettingsPage() {
    goToPage(BasetenPageEnum.TeamSettings, { teamId: selectedTeamId });
  }

  return (
    <Popover open={!!anchorEl} onClose={() => onClose()} anchorEl={anchorEl}>
      <Container>
        <Section gap={1}>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Avatar emoji={!!selectedTeam?.icon} sx={{ width: 32, height: 32 }}>
              {selectedTeam?.icon || first(selectedTeam?.name)}
            </Avatar>
            <Stack gap={0.25}>
              <Typography variant="h5">{selectedTeam?.name}</Typography>
              <Stack direction="row" gap={0.25}>
                <Typography variant="body2" color="text.muted">
                  Admin
                </Typography>
                <Typography variant="body2" color="text.muted">
                  ·
                </Typography>
                <Typography variant="body2" color="text.muted">
                  8 members
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack direction="row" gap={1} alignItems="center">
            <Button variant="outlined" startIcon={<SettingsIcon />} onClick={goToTeamSettingsPage}>
              Manage
            </Button>
            <Button variant="outlined" startIcon={<UserPlusIcon />}>
              Add
            </Button>
          </Stack>
        </Section>
        <Section gap={1}>
          <Typography variant="h6" color="text.muted">
            Switch teams
          </Typography>
          <Stack gap={0.2}>
            {teams?.map((team) => (
              <MenuItem
                key={team.id}
                onClick={() => onSelectTeam(team.id)}
                selected={team.id === selectedTeamId}
                sx={{ p: 0.5 }}
              >
                <TeamResource>
                  <TeamResourceName>
                    <Avatar emoji={!!team.icon}>{team.icon || first(team.name)}</Avatar> {team.name}
                  </TeamResourceName>
                </TeamResource>
              </MenuItem>
            ))}
          </Stack>
        </Section>
        <Section>
          <MenuItem sx={{ p: 1 }} onClick={() => dialogs.open(CreateTeam) && onClose()}>
            <TeamResource>
              <TeamResourceName>
                <PlusIcon /> Create new team
              </TeamResourceName>
            </TeamResource>
          </MenuItem>
        </Section>
      </Container>
    </Popover>
  );
}

export default ManagePopover;
